// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationResponse
 */
export interface ConversationResponse {
    /**
     * 
     * @type {string}
     * @memberof ConversationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationResponse
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof ConversationResponse
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the ConversationResponse interface.
 */
export function instanceOfConversationResponse(value: object): value is ConversationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ConversationResponseFromJSON(json: any): ConversationResponse {
    return ConversationResponseFromJSONTyped(json, false);
}

export function ConversationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function ConversationResponseToJSON(json: any): ConversationResponse {
    return ConversationResponseToJSONTyped(json, false);
}

export function ConversationResponseToJSONTyped(value?: ConversationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

